import { types } from "../types/types";

const initialState = {
  catalogCiiuInfo: {},
};
export const catalogCiiuInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGCIIU_INFO_START_LOADING_BY_ID:
      return {
        ...state,
        catalogCiiuInfo: action.payload,
      };

    default:
      return state;
  }
};
